module.exports = __webpack_public_path__ + "021a6e95336b597bbafd828dca75db46.pdf";